---
de:
  admin:
    power_plants:
      delete_data:
        confirm_hint: Dies kann nicht rückgängig gemacht werden. Geben Sie den Anlagennamen "{name}" ein, um zu bestätigen.
        confirm_label: Anlagenname
        counts:
          downtime_days: Ausfalltage
          downtime_events: Ausfallereignisse
          downtime_periods: Ausfallstunden
          orphaned_downtime_events: Unvollständig zurückbleibende Ausfallereignisse
          production_days: Produktionstage
          production_periods: Produktionszeiträume
          production_quarters: Produktionsviertelstunden
          revenue_periods: Ertragszeiträume
          verified_downtime_events: Verifizierte Ausfallereignisse
        delete: Daten löschen
        deleted_body: "{count} Zeilen entfernt."
        deleted_title: Produktionsdaten gelöscht
        deleting: Löschen läuft. Schließen Sie dieses Dialogfenster nicht, bevor der Vorgang abgeschlossen ist.
        description: Entfernt dauerhaft die Produktions- und Ausfalldaten dieser Anlage im gewählten Zeitraum. Zeigen Sie zuerst die Auswirkung an, dann bestätigen Sie.
        error: Etwas ist schiefgelaufen. Es wurden keine Daten gelöscht.
        errors:
          busy: Ein anderer Job schreibt gerade die Produktionsdaten dieser Anlage. Es wurde nichts gelöscht — bitte in einigen Minuten erneut versuchen.
        from: Von
        menu: Produktionsdaten löschen
        preview: Auswirkung anzeigen
        rows_header: Zu löschende Zeilen
        table_header: Daten
        title: 'Produktionsdaten löschen: {name}'
        to: Bis
        verified_blocked: Der Zeitraum überschneidet sich mit verifizierten Ausfallereignissen, daher wird das Löschen abgelehnt. Heben Sie die Verifizierung auf oder schränken Sie den Zeitraum ein.
